import { useDynamicForm } from "@/components/dynamic-form/hook/useDynamicForm";
import { enhanceEndDate } from "@/components/dynamic-form/formatter/enhanceEndTime";
import { getInitialValues } from "@/components/dynamic-form/helper/getInitialValues";
import { DynamicForm } from "@/components/dynamic-form";
import { useGlobalStore } from "@/store/GlobalStore";
import { PageContainer } from "@/components/page-container";
import { TableContainer } from "@/components/table-container";
import { Table } from "@renderbus/ui";
import { AuthEditDrawer } from "@/pages/authorization-management/components/auth-edit-drawer";
import { columns } from "./config/table-columns";
import {
  useFormConfig,
  useTaskIdConfig,
} from "@/pages/operate-record/hooks/useFormConfig";
import { Channel } from "./types";
import { useImmediateFetch } from "@/components/dynamic-form/hook/useImmediateFetch";
import { useWatchPagination } from "@/components/dynamic-form/hook/useWatchPagination";
import { useAuthManageStore } from "@/pages/authorization-management/store/auth-manage-store";
import { AuthManageStoreProvider } from "@/pages/authorization-management/store/auth-manage-store";
import request from "project-config/services/request/request";
import { ModuleType } from "@/pages/operate-record/types";
import { useTranslation } from "react-i18next";

export function OperateRecordView() {
  const { userInfo, isZh } = useGlobalStore();
  const { t } = useTranslation("center");
  const { form, tableData, fetchData, pageNum, setPageNum, pageSize, total } =
    useDynamicForm({
      api: "/api/rendering/task/operateRecord/taskRecord",
      defaultPageNum: 1,
      defaultPageSize: 10,
      formatter: {
        time: enhanceEndDate,
        taskType: (v) => (v === "All" ? undefined : v),
        channel: (v) => (v === Channel.ALL ? undefined : v),
        taskIds: (v) => (showTaskId ? v : undefined),
      },
    });

  const fetch = (defaultPageNum?: number) =>
    fetchData({
      extraData: {
        platform: userInfo?.platform,
        pageNum: defaultPageNum || pageNum,
      },
    });

  const { setOpenEditAuthDrawer, setAuthRecord } = useAuthManageStore();

  useImmediateFetch(fetch);
  useWatchPagination(pageSize, pageNum, fetch);

  // todo shit
  const { searchConfig } = useFormConfig();
  const { showTaskId } = useTaskIdConfig(form);
  const currentColumns = isZh
    ? [...columns]
    : [...columns.filter((item) => item.title !== t("operation_detail"))];
  return (
    <PageContainer>
      <TableContainer>
        <DynamicForm
          initialValues={getInitialValues(searchConfig)}
          searchConfig={searchConfig}
          searchForm={form}
          onSearch={() => fetch()}
          showButtonIcon
        />

        <Table
          paginationCurrent={pageNum}
          columns={currentColumns}
          dataSource={tableData}
          defaultPageSize={pageSize}
          total={total}
          gap={false}
          onPageNumChange={async (num) => {
            setPageNum(num);
          }}
          onRow={(row) => {
            const { details, taskType } = row;
            return {
              onClick: async (e: any) => {
                if (
                  taskType !== ModuleType.UserAuth ||
                  e.target.text !== t("user_auth_details")
                )
                  return;
                const { data } = await request.post(
                  "/api/rendering/user/userAuth/queryUserAuthRecord",
                  { id: Number(details) }
                );
                setAuthRecord(data);
                setOpenEditAuthDrawer(true);
              },
            };
          }}
        />
        <AuthEditDrawer isOnlyView={true} />
      </TableContainer>
    </PageContainer>
  );
}

export function OperateRecord() {
  return (
    <AuthManageStoreProvider>
      <OperateRecordView />
    </AuthManageStoreProvider>
  );
}
